"use strict";

exports.__esModule = true;
/**
 * Check if a value in validList
 * @param {String} value
 * @param {Array} validList
 * @return {Boolean}
 */
var oneOf = exports.oneOf = function oneOf(value, validList) {
  return validList.indexOf(value) > -1;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bic-fe/mds-ui/dist/_util/proptype.js
// module id = UAEV
// module chunks = 0